'use strict';
/**
 * Modifications to dataTables.tribal.js to make this closer to http://www.st-andrews.ac.uk/~cdn/dpl/0.5.3/scripts/datatables.js
 */

(function(window, document, undefined) {
	
	var dplFactory = function($, DataTable) {
		
		$.extend(true, DataTable.defaults, {
			dom:
				'<"sv-row dt-pre"<"sv-col-md-6"<"dt-title">><"sv-col-md-6 sv-text-right"f>>'+
				'<"sv-row dt-table"<"sv-col-sm-12"tr>>' +
				'<"sv-row dt-post"<"sv-col-md-6"p><"sv-col-md-6 sv-text-right"il>>',
			preDrawCallback: function(settings) {
				var container = $(this.api().table().container()),
					table = $(this.api().table()),
					padding = table.find('th').css('padding');

				container.find('.dt-title').css('padding',padding);
				container.find('.dataTables_filter').css('padding',padding);
			},
			language: {
				info: '_START_ to _END_ of _TOTAL_ rows',
				infoEmpty: '0 rows',
				infoFiltered: 'filtered from _MAX_ total rows',
				paginate: {
					previous: '&laquo;',
					next: '&raquo;'
				},
				processing: 'Loading...',
				search: 'Filter '
			},
			lengthChange: false, // disable the num of rows selector
			pageLength: 15,
			processing: true
		});	
	}; // dplFactory
	
	// Define as an AMD module if possible
	if (typeof define === 'function' && define.amd) {
		define(['jquery', 'datatables'], dplFactory);
	}

	else if (typeof exports === 'object') {
		// Node/CommonJS
		dplFactory(require('jquery'), require('datatables'));
	}
	else if (jQuery) {
		// Otherwise simply initialise as normal, stopping multiple evaluation
		dplFactory(jQuery, jQuery.fn.dataTable);
	}

	// Auto setup any tables with class 'dataTable'
	$('.dataTable').DataTable();
})(window, document);